import { createAction, props } from "@ngrx/store";
import { Filters } from "./se-timeline.state";

export enum SeTimelineComponentActions {
    SET_PATIENT = '[SeTimelineComponent] SetPatient',
    SET_SELECTED_ITEM = '[SeTimelineComponent] SetSelectedItem',
    SET_DATA = '[SeTimelineComponent] SetData',
    SET_REPORT = '[SeTimelineComponent] SetReport',
    UPDATE_DATA = '[SeTimelineComponent] UpdateData',
    UPDATE_REPORT = '[SeTimelineComponent] UpdateReport',
    SET_FILTERS = '[SeTimelineComponent] SetFilters',
    SET_REPORT_FILTERS = '[SeTimelineComponent] SetReportFilters',
}

export const seTimelineComponentSetPatient =
    createAction(SeTimelineComponentActions.SET_PATIENT, props<{ formType : any; patientId : string; isAllBuSearch ?: boolean; }>());

export const seTimelineComponentSetSelectedItem =
    createAction(SeTimelineComponentActions.SET_SELECTED_ITEM, props<{ formType : any; selectedItem : any; }>()); // formType retrieved from setPatient

export const seTimelineComponentSetData =
    createAction(SeTimelineComponentActions.SET_DATA, props<{ data : any[] }>());

export const seTimelineComponentUpdateData =
    createAction(SeTimelineComponentActions.UPDATE_DATA, props<{ data : any[]; }>());

export const seTimelineComponentSetFilters =
    createAction(SeTimelineComponentActions.SET_FILTERS, props<{ filters: Filters; }>());

export const seTimelineComponentSetReport =
    createAction(SeTimelineComponentActions.SET_REPORT, props<{ report: any[]; }>());

export const seTimelineComponentUpdateReport =
    createAction(SeTimelineComponentActions.UPDATE_REPORT, props<{ report: any[]; }>());

export const seTimelineComponentSetReportFilters =
    createAction(SeTimelineComponentActions.SET_REPORT_FILTERS, props<{ filters: Filters; }>());


